import axios from "axios";
// const host = "http://192.168.0.22:3002";
// const host = process.env.VUE_APP_URL_API;
const host = "https://api.cosmoscode.com.br/lucromil/";
// const host = "https://api-lucromil.cosmoscode.com.br/";

let http = axios.create({
  // baseURL: "https://stonepro.cosmoscode.com.br/p/",
  baseURL: host,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${
      sessionStorage.token ? JSON.parse(sessionStorage.token) : ""
    }`
  }
});

http.interceptors.request.use(
  function(config) {
    config.headers.Authorization = `Bearer ${
      sessionStorage.token ? JSON.parse(sessionStorage.token) : ""
    }`;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

export default http;
